module.exports = __webpack_public_path__ + "img/mediapal-blue.9990c413.svg";